import arduinoCores from '../../constants/arduino-cores.json' with { type: 'json' };
import arduinoLibraries from '../../constants/arduino-libraries.json' with { type: 'json' };

export {
  PROTOCOL_VERSION,
  HELPER_DEFAULT_PORT,
  HELPER_API_BASE_PATH,
  HELPER_WS_PATH,
  PROJECT_FORMAT_VERSION,
  PROJECT_FILE_EXTENSION,
  HELPER_ALLOWED_ORIGINS,
  HELPER_DEV_ORIGIN,
  SERIAL_DEFAULT_BAUD,
  SERIAL_SUPPORTED_BAUDS,
  SERIAL_LINE_ENDINGS,
  WORKSPACE_AUTOSAVE_DEBOUNCE_MS,
  HELPER_RECONNECT_INTERVAL_MS,
  HELPER_TOKEN_MIN_LENGTH,
  HELPER_DOWNLOAD_PATH,
} from './protocol.js';

export type { SerialLineEnding } from './protocol.js';

/** Pinned Arduino core versions for helper first-run setup */
export const ARDUINO_CORES = arduinoCores.cores;

export type ArduinoCoreEntry = (typeof ARDUINO_CORES)[number];

/** Maps sketch #include headers to Arduino Library Manager package names */
export const ARDUINO_LIBRARIES = arduinoLibraries.libraries;

export type ArduinoLibraryEntry = (typeof ARDUINO_LIBRARIES)[number];
